export default "__VITE_ASSET__DboM_B8B__"